import React from "react";
import classNames from "classnames/bind";
import styles from "../../AddJobModal.module.scss";
import CustomInput from "../../custom-component/CustomInput";
import { JobFormData, JobFormErrors } from "../../types/add-job.types";
import { PolicyTypeOptions } from "../../constants/add-job.constants";
import { ISalesRep } from "~/apis/userManagement";

const cx = classNames.bind(styles);

interface InsuranceFormProps {
  formData: JobFormData;
  errors: JobFormErrors;
  salesReps: ISalesRep[];
  onFieldChange: (field: keyof JobFormData, value: any) => void;
  onErrorFieldChange: (field: keyof JobFormErrors, value: string) => void;
}

const InsuranceForm: React.FC<InsuranceFormProps> = ({
  formData,
  errors,
  salesReps,
  onFieldChange,
  onErrorFieldChange,
}) => {
  const handleSalesRepChange = (value: string) => {
    const selectedRep = salesReps.find((opt) => opt.username === value);
    onFieldChange("salesRepId", selectedRep?.id || "");
    if (!selectedRep?.id) {
      onErrorFieldChange("salesRepId", "Sales rep is required");
    } else {
      onErrorFieldChange("salesRepId", "");
    }
  };

  return (
    <div className="flex gap-[9px]">
      {/* Insurance - Left Column */}
      <div className={cx("item", "w-[50%]")}>
        <div className={cx("item")}>
          <h4 className={cx("item-title")}>Insurance company Name</h4>
          <CustomInput
            type="input"
            placeholder="Enter Insurance company name"
            value={formData.insuranceCompanyName}
            onChange={(value) => onFieldChange("insuranceCompanyName", value)}
          />
        </div>

        <div className={cx("item")}>
          <h4 className={cx("item-title")}>Claim Number</h4>
          <CustomInput
            type="input"
            placeholder="Enter claim number"
            value={formData.claimNumber}
            onChange={(value) => onFieldChange("claimNumber", value)}
          />
        </div>

        <div className={cx("item")}>
          <h4 className={cx("item-title")}>Adjuster Name (Optional)</h4>
          <CustomInput
            type="input"
            placeholder="Enter adjuster name"
            value={formData.adjusterName}
            onChange={(value) => onFieldChange("adjusterName", value)}
          />
        </div>

        <div className={cx("item")}>
          <h4 className={cx("item-title")}>Sales Rep</h4>
          <CustomInput
            type="select"
            selectPlaceholder="Select"
            selectOptions={salesReps.map((option) => option.username)}
            value={
              salesReps.find((opt) => opt.id === formData.salesRepId)
                ?.username || ""
            }
            onSelectChange={handleSalesRepChange}
          />
          {errors.salesRepId && (
            <p className={cx("error-message")}>{errors.salesRepId}</p>
          )}
        </div>
      </div>

      {/* Insurance - Right Column */}
      <div className={cx("item", "w-[50%]")}>
        <div className={cx("item")}>
          <h4 className={cx("item-title")}>Email</h4>
          <CustomInput
            type="input"
            placeholder="Enter email"
            value={formData.insuranceEmail}
            onChange={(value) => onFieldChange("insuranceEmail", value)}
          />
        </div>

        <div className={cx("item")}>
          <h4 className={cx("item-title")}>Phone Number</h4>
          <CustomInput
            type="input"
            placeholder="Enter phone"
            value={formData.insurancePhoneNumber}
            onChange={(value) => onFieldChange("insurancePhoneNumber", value)}
          />
        </div>

        <div className={cx("item")}>
          <h4 className={cx("item-title")}>Policy Type</h4>
          <CustomInput
            type="select"
            selectPlaceholder="Select policy"
            selectOptions={PolicyTypeOptions.map((option) => option.label)}
            value={
              PolicyTypeOptions.find((opt) => opt.value === formData.policyType)
                ?.label || ""
            }
            onSelectChange={(value) => {
              const selectedPolicy = PolicyTypeOptions.find(
                (opt) => opt.label === value
              );
              onFieldChange("policyType", selectedPolicy?.value || "");
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default InsuranceForm;



